function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M30 33H23.0547V31.4961L26.2539 28.1328C27.0423 27.235 27.4365 26.5218 27.4365 25.9932C27.4365 25.5648 27.3431 25.2389 27.1562 25.0156C26.9694 24.7923 26.6982 24.6807 26.3428 24.6807C25.9919 24.6807 25.707 24.8311 25.4883 25.1318C25.2695 25.4281 25.1602 25.7995 25.1602 26.2461H22.8496C22.8496 25.6354 23.0023 25.0726 23.3076 24.5576C23.613 24.0381 24.0368 23.6325 24.5791 23.3408C25.1214 23.0492 25.7275 22.9033 26.3975 22.9033C27.473 22.9033 28.3001 23.1517 28.8789 23.6484C29.4622 24.1452 29.7539 24.8584 29.7539 25.7881C29.7539 26.18 29.681 26.5628 29.5352 26.9365C29.3893 27.3057 29.1615 27.6953 28.8516 28.1055C28.5462 28.5111 28.0518 29.0557 27.3682 29.7393L26.083 31.2227H30V33Z",
  fill: "black"
});

function SvgCart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart2);
export default __webpack_public_path__ + "static/media/cart2.ee6cada0.svg";
export { ForwardRef as ReactComponent };